import { Input } from "antd";

export default function Search({ text, searchInput, handleSearch }) {
  return (
    <>
      <div className="search">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 4.5C5.79086 4.5 4 6.29086 4 8.5C4 10.7091 5.79086 12.5 8 12.5C10.2091 12.5 12 10.7091 12 8.5C12 6.29086 10.2091 4.5 8 4.5ZM2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5C14 9.79583 13.5892 10.9957 12.8907 11.9765L17.7071 16.7929C18.0976 17.1834 18.0976 17.8166 17.7071 18.2071C17.3166 18.5976 16.6834 18.5976 16.2929 18.2071L11.4765 13.3907C10.4957 14.0892 9.29583 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5Z"
            fill="#9CA3AF"
          />
        </svg>

        <Input
          onChange={handleSearch}
          value={searchInput}
          placeholder={text}
          className="input-borderless"
          type="text"
        />
      </div>
    </>
  );
}
